import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const EmbeddedMap = ({ location, coords = null }) => {
    const apiKey = 'AIzaSyCVdZyXs2CznoUWsZyrOQoRvz9oK74whzc';

    // Customizing the embed URL
    var mapUrl = '';
    if (coords != null) {
        mapUrl = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${encodeURIComponent(`${coords.lat},${coords.lng}`)}&zoom=15&maptype=satellite`;
    } else {
        mapUrl = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${encodeURIComponent(location)}&zoom=15&maptype=satellite`;
    }

    return (
        <div style={{ width: '100%', height: '400px' }}>
            <iframe
                title="Google Maps Embed"
                width="100%"
                height="100%"
                frameBorder="0"
                style={{ border: 0 }}
                src={mapUrl}
                allowFullScreen
            ></iframe>
        </div>
    );
};

export default EmbeddedMap;

